import { AppRouteProps } from "@bsm/component";
import { TeacherDetailsAboutRoutes } from "./about/TeacherDetailsAboutRoutes";
import { TeacherDetailsParamsRoutes } from "./params/TeacherDetailsParamsRoutes";

export const TeacherDetailsViewsRoutes: Array<AppRouteProps> = [
    ...TeacherDetailsAboutRoutes,
    ...TeacherDetailsParamsRoutes
]